import { Flex, Heading } from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import StaticContentFrame from "../StaticContentFrame";
import { MITO_POWERED_BY } from "../../utils/constants";
import { mitoOrangeLayout } from "../../theme/mitoOrangeLayout";

type LegalStripProps = {
  isMobile?: boolean;
  onToggle?: () => void;
  toggleOpen?: boolean;
};

const LegalStrip = ({ isMobile, onToggle, toggleOpen }: LegalStripProps) => {
  const strip = mitoOrangeLayout.legalStrip;

  return (
    <Flex
      align={strip.align}
      justify={strip.justify}
      ml={strip.ml}
      flexWrap={strip.flexWrap}
      flexDir="row"
      gap={{ sm: "1", lg: "0" }}
      pos="relative"
      flexShrink={0}
    >
      <Heading
        as="p"
        size="md_light"
        color={strip.color}
        textTransform="initial"
        whiteSpace="nowrap"
      >
        {MITO_POWERED_BY}
      </Heading>
      {isMobile && onToggle ? (
        <FaChevronDown
          color="rgba(155, 155, 155, 1)"
          fontSize="18px"
          onClick={onToggle}
          style={{ cursor: "pointer" }}
        />
      ) : null}
      <StaticContentFrame toggleData={!!toggleOpen} />
    </Flex>
  );
};

export default LegalStrip;
